export interface Ancillaries {
  accommodations?: Array<SelectedHotel>;
  activities?: Array<SelectedExtra>;
  groundTransportations?: Array<SelectedExtra>;
  vehicles?: Array<SelectedVehicle>;
  tripInsurance?: Array<SelectedTripInsurance>;
}

export interface SelectedVehicle {
  confirmationNum?: string;
  brandName?: string;
  desc: string;
  vendorName: string;
  primaryDriver: string;
  primaryDriverName?: string;
  daysBooked: number;
  pickUp: PickUpDropOff;
  dropOff: PickUpDropOff;
  passengerCapacity?: number;
  bagCapacity?: number;
  addedValues?: Inclusive[];
  preferences?: GenericItem[];
  link?: string;
}

export interface PickUpDropOff {
  description: string;
  countryCode: string;
  timeVisit: string;
  alwaysOpen: boolean;
}

export interface SelectedHotel {
  vendorName: string;
  brandName?: string;
  addedValues?: Inclusive[];
  address: PostalAddress;
  checkinDt?: string;
  checkoutDt?: string;
  confirmationNum?: string;
  link?: string;
  nightsBooked: number;
  preferences?: GenericItem[];
  purchaseDt?: string;
  rating: string;
  rooms: SelectedRoom[];
}

export interface SelectedRoom {
  addedValues?: Inclusive[];
  confirmationNum?: string;
  desc: string;
  id: number;
  preferences?: GenericItem[];
  reservedForPassengers: string[];
}

export interface PostalAddress {
  cityName: string;
  country: GenericItem;
  countrySubdivision?: GenericItem;
  postalCode: string;
  street: string;
}

export interface Inclusive {
  desc: string;
  infoKey?: string;
  subTypeCode?: string;
  typeCode?: string;
}

export interface GenericItem {
  code?: string;
  name: string;
}

export interface SelectedExtra {
  passengerCnt: number;
  passengerResourceId: string[];
  name?: string;
  link?: string;
  confirmationNum?: string;
  desc?: string;
  activityDt?: string;
  serviceType?: string;
  serviceDesc?: string;
  serviceDetails?: string;
  startDt?: string;
  endDt?: string;
  addedValues?: Inclusive[];
  imageError?: boolean;
}

export interface SelectedTripInsurance {
  insurancePlans: TripInsurancePlan[];
  reservedForPassengers: string[];
  confirmationNum?: string;
  currencyCode?: string;
  totalPrice?: string;
}

export interface TripInsurancePlan {
  code: string;
  desc: string;
  details: Array<string>;
}
